import "./style.css";
import layout from "./layout.html";

export default class RoomsImages {
  static selector = ".rooms__images";

  constructor(block) {
    this.block = block;
    this.block.innerHTML = layout;
  }

  onReady = () => {};

  onComplete = () => {};

  onResize = () => {};
}
